import React from "react";
import logo from '../images/OTK_wordmark_horiz_green.png';

export default function Nav() {
    return (
        <div className="nav-and-photo">
            <header>
                <nav>
                    <div className="nav-image"><a href="/"><img className="nav-logo" src={logo} alt="One Thing Knead Wordmark" /></a></div>
                    <div className="nav-button-section">
                        <div className="nav-button"><a href="/order">Order</a></div>
                        <div className="nav-button"><a href="/classes">Classes</a></div>
                        <div className="nav-button"><a href="/about">About</a></div>
                    </div>

                </nav>
            </header>
        </div>
    )
}